import React from "react";
import { classNames } from "src/helpers/classNames";
import { Loader2 } from "../shared/LoadingAnimations/Loader2";
import Preloader from "../shared/LoadingAnimations/Preloader";

export default function ContentLoading({ menuType, nested, overlay = false, altLoader = false }) {
  return (
    <div
      className={classNames(
        "flex items-center justify-center ",
        menuType === "vertical" ? "" : "", // for vertical h-full
        nested ? "h-full" : "",
        overlay && "absolute inset-0 z-[39] bg-gradient-to-br from-slate-50 via-gray-100 to-slate-200 ",
      )}>
      <div className={classNames("flex h-full w-full  justify-center bg-backgroundColor", altLoader ? "items-start  pt-9" : "items-center")}>
        {altLoader ? (
          <Loader2
            size="xlg"
            textClass={"hidden"}
          />
        ) : (
          <Preloader />
        )}
      </div>
    </div>
  );
}
